module.exports = __webpack_public_path__ + "img/data.5436a9aa.svg";